import { useBionicReading, toBionicText } from '../../contexts/BionicReadingContext';

export const BionicText = ({ children, className = '' }) => {
  const { bionicEnabled } = useBionicReading();

  if (!bionicEnabled || typeof children !== 'string') {
    return <span className={className}>{children}</span>;
  }

  return (
    <span className={`bionic-text ${className}`}>
      {toBionicText(children)}
    </span>
  );
};
